"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValleyBankCollateralAccountSchema = exports.ValleyBankHistoricalLoanAccountToPinnedCommentSchema = exports.ValleyBankSubLoanAccountSchema = exports.ValleyBankSubLoanAccountTypeSchema = exports.finleyAssignmentFieldsIterable = exports.FinleyValleyBankResponseTapeRowSchema = exports.ValleyBankRequiredBaseFieldsSchema = exports.valleyBankRequiredBaseFieldsIterable = exports.FinleyDerivativePathSchema = exports.ValleyBankDerivativePathSchema = exports.FinleyVanProductSchema = exports.ValleyBankVanProductSchema = exports.FinleyVanListSchema = exports.ValleyBankVanListSchema = exports.ValleyBankCollateralToLoanAccountMappingSchema = exports.FinleyPsPlusSecMasterSchema = exports.ValleyBankBloombergMutualFundSchema = exports.ValleyBankPsPlusSecMasterSchema = exports.FinleyPsPlusSecDetailSchema = exports.ValleyBankPsPlusSecDetailSchema = exports.FinleyPsPlusAccountSchema = exports.ValleyBankPsPlusAccountSchema = exports.FinleyPsPlusPortfolioSchema = exports.ValleyBankPsPlusPortfolioSchema = exports.FinleyCuoMaintSchema = exports.ValleyBankCuoMaintSchema = exports.FinleyCuoLoanSchema = exports.ValleyBankCuoLoanSchema = exports.FinleyVanCmmtSchema = exports.ValleyBankVanCmmtSchema = exports.FinleyLoanCustRelSchema = exports.ValleyBankLoanCustRelSchema = exports.FinleyVanLoanAcctSchema = exports.ValleyBankVanLoanAcctSchema = exports.FinleyCuoDepositSchema = exports.ValleyBankCuoDepositSchema = exports.FinleyCuoCollatSchema = exports.ValleyBankCuoCollatSchema = exports.FinleyCollatCustRelSchema = exports.ValleyBankCollatCustRelSchema = exports.FinleyVanDepAcctSchema = exports.ValleyBankVanDepAcctSchema = exports.FinleyVanCustAcctRelSchema = exports.ValleyBankVanCustAcctRelSchema = exports.ValleyBankAccountCollateralTypeSchema = exports.ValleyBankAccountCollateralTypesIterable = exports.FinleyLoanPartySchema = exports.FinleyVanCustWithOfficerSchema = exports.FinleyVanCustSchema = exports.ValleyBankVanCustSchema = void 0;
exports.VALLEY_BANK_AUTH_ADVANCE_RATE_SCOPES = exports.VALLEY_BANK_AUTH_ASSIGNMENT_SCOPES = exports.VALLEY_BANK_USER_ROLES = exports.ValleyBankCollateralAccountStatsSchema = exports.ValleyBankLoanAccountStatsSchema = exports.ValleyBankArrangementGroupSchema = exports.ValleyBankPipelineStatusMetadataSchema = exports.ValleyBankPortfolioReceivableResponseTapeStatsSchema = exports.ValleyBankPortfolioReceivableResponseTapeSchema = exports.ValleyBankWorkleaseSchema = exports.ValleyBankArchiveWorkleaseSchema = exports.ValleyBankRestoreWorkleaseSchema = exports.ValleyBankReceivableResponseTapeWorkleaseSchema = exports.ValleyBankCustomerWithRelationshipsSchema = exports.ValleyBankLoanAccountWithCollateralAndStatsSchema = exports.ValleyBankLoanAccountWithCollateralStatsSchema = exports.ValleyBankCustomerSchema = void 0;
/* eslint-disable camelcase */
const zod_1 = require("zod");
const finley_types_1 = require("@finley-technologies/finley-types");
// ################################
// #
// # CUSTOMER
// #
// ################################
/**
 * Customers table
 * VANCUST.TXT
 */
exports.ValleyBankVanCustSchema = zod_1.z.object({
    cif_num: zod_1.z.string(),
    bank_num: zod_1.z.string(),
    full_name: zod_1.z.string(),
    first_name: zod_1.z.string().nullable(),
    last_name: zod_1.z.string().nullable(),
    branch_code: zod_1.z.string(),
    officer_code: zod_1.z.string(), // @MAPME to officer => VANLIST#OFFICERCODE
    customer_since: finley_types_1.Util.ZodFullDateStrStruct,
    naics_code: zod_1.z.string().nullable(),
    address_1: zod_1.z.string().nullable(),
    address_2: zod_1.z.string().nullable(),
    city: zod_1.z.string().nullable(),
    state: zod_1.z.string().nullable(),
    zip_code: zod_1.z.string().nullable(),
    ci_risk_rt: zod_1.z.string().nullable(),
    prospcd: zod_1.z.string(), // C P E
});
exports.FinleyVanCustSchema = exports.ValleyBankVanCustSchema.extend({
    reportingDate: finley_types_1.Util.ZodFullDateStrStruct,
});
exports.FinleyVanCustWithOfficerSchema = exports.FinleyVanCustSchema.extend({
    officer: zod_1.z.string().nullable(),
});
exports.FinleyLoanPartySchema = exports.FinleyVanCustWithOfficerSchema.extend({
    rel_code: zod_1.z.string().nullable(),
    rel_code_description: zod_1.z.string().nullable(),
});
// ################################
// #
// # COLLATERAL ACCOUNTS
// #
// ################################
exports.ValleyBankAccountCollateralTypesIterable = [
    'IBS',
    'OPICS',
    'PSPLUS',
];
exports.ValleyBankAccountCollateralTypeSchema = zod_1.z.enum(exports.ValleyBankAccountCollateralTypesIterable);
/**
 * Van Customer Account Relationship
 * VANCUSTACCTREL.TXT
 */
exports.ValleyBankVanCustAcctRelSchema = zod_1.z.object({
    bank_num: zod_1.z.string(),
    app_code: zod_1.z.enum(['DP', 'LN']), // DP for deposit, LN for loan
    account_id: zod_1.z.string(), // analogous to account_num
    cif_num: zod_1.z.string(),
    rel_code: zod_1.z.string(),
});
exports.FinleyVanCustAcctRelSchema = exports.ValleyBankVanCustAcctRelSchema.extend({
    reportingDate: finley_types_1.Util.ZodFullDateStrStruct,
});
/**
 * Van Deposit Account
 * VANDEPACCT.TXT
 */
exports.ValleyBankVanDepAcctSchema = zod_1.z.object({
    account_id: zod_1.z.string(),
    bank_num: zod_1.z.string(),
    account_type_code: zod_1.z.string(), // account_type => VANLIST#DEPOSITACCOUNTTYPE
    account_num: zod_1.z.string(),
    cif_num: zod_1.z.string(),
    product_code: zod_1.z.string().nullable(), // product_description, app_subcode => VANPRODUCT#ProductCode
    opened_date: finley_types_1.Util.ZodFullDateStrStruct,
    interest_rate: zod_1.z.number(),
    maturity_date: zod_1.z.string().nullable(),
    cur_balance: zod_1.z.number(),
    status_code: zod_1.z.string().nullable(),
    branch_num: zod_1.z.string(),
    employee_code: zod_1.z.string(),
    account_name: zod_1.z.string().nullable(),
});
exports.FinleyVanDepAcctSchema = exports.ValleyBankVanDepAcctSchema.extend({
    reportingDate: finley_types_1.Util.ZodFullDateStrStruct,
});
/**
 * Valley Bank Collateral Customer Relationship
 * collat_cust_rel.TXT
 */
exports.ValleyBankCollatCustRelSchema = zod_1.z.object({
    as_of_date: finley_types_1.Util.ZodFullDateStrStruct,
    bsys_code: zod_1.z.string(),
    bank_number: zod_1.z.string(),
    he_coll_id: zod_1.z.string(),
    cif_num: zod_1.z.string().nullable(),
    portfolio_number: zod_1.z.string().nullable(),
});
exports.FinleyCollatCustRelSchema = exports.ValleyBankCollatCustRelSchema.extend({
    reportingDate: finley_types_1.Util.ZodFullDateStrStruct,
});
/**
 * CUO.COLLAT
 * DP Holds to Collat.TXT
 */
exports.ValleyBankCuoCollatSchema = zod_1.z.object({
    hecoll_id: zod_1.z.string(),
    hecoll_bsys_id: zod_1.z.string().nullable(),
    hecoll_desc: zod_1.z.string(),
    hecoll_account_hold_amount: zod_1.z.number().nullable(),
    hecoll_file_date: zod_1.z.string().nullable(),
    hecoll_current_appraisal: zod_1.z.number(),
    hecoll_type_code: zod_1.z.string(), // @MAPME to account_type => VANLIST#DEPOSITACCOUNTTYPE
    hecoll_deposit_acct_type_id: zod_1.z.string().nullable(),
    hecoll_deposit_account_num: zod_1.z.string().nullable(),
    hecoll_deposit_balance: zod_1.z.number().nullable(),
    hecoll_maturity_dt: zod_1.z.string(),
    hecoll_frgn_currency_ind: zod_1.z.string().nullable(),
    hecoll_frgn_currency_code: zod_1.z.string().nullable(),
    hecoll_frgn_cur_amt: zod_1.z.number().nullable(),
    hecoll_frgn_cur_xfr_rate: zod_1.z.number().nullable(),
    hecoll_source_system: zod_1.z.string().nullable(),
    hecoll_pledged_ind: zod_1.z.string(),
});
exports.FinleyCuoCollatSchema = exports.ValleyBankCuoCollatSchema.extend({
    reportingDate: finley_types_1.Util.ZodFullDateStrStruct,
});
/**
 * CUODEPOSIT
 * OPICS TD to Deposits
 */
exports.ValleyBankCuoDepositSchema = zod_1.z.object({
    hedeposit_bsys_id: zod_1.z.string(),
    cif_num: zod_1.z.string().nullable(),
    hedeposit_acct_num: zod_1.z.string(), // account_num
    hedeposit_acct_type: zod_1.z.string(),
    hedeposit_cur_bal: zod_1.z.number(),
    hedeposit_avg_bal: zod_1.z.number().nullable(),
    hedeposit_nsf_tot: zod_1.z.number().nullable(),
    hedeposit_last_nsf_dt: zod_1.z.string().nullable(),
    hedeposit_last_nsf_amt: zod_1.z.number().nullable(),
    hedeposit_last_activity_dt: zod_1.z.string().nullable(),
    hedeposit_last_deposit_dt: zod_1.z.string().nullable(),
    hedeposit_tot_nsf_checks_paid_ytd: zod_1.z.number().nullable(),
    hedeposit_acct_open_dt: finley_types_1.Util.ZodFullDateStrStruct,
    hedeposit_branch_num: zod_1.z.string().nullable(),
    hedeposit_acct_status: zod_1.z.string(),
    hedeposit_acct_name: zod_1.z.string().nullable(),
    hedeposit_branch_desc: zod_1.z.string().nullable(),
    hedeposit_frgn_currency_code: zod_1.z.string(),
    hedeposit_frgn_cur_amt: zod_1.z.number(),
    hedeposit_frgn_cur_xfr_rate: zod_1.z.number(),
    hedeposit_frgn_avail_bal: zod_1.z.number(),
    hedeposit_frgn_orig_amt: zod_1.z.number(),
    hedeposit_avail_bal: zod_1.z.number(),
});
exports.FinleyCuoDepositSchema = exports.ValleyBankCuoDepositSchema.extend({
    reportingDate: finley_types_1.Util.ZodFullDateStrStruct,
});
// ################################
// #
// # LIABILITIES
// #
// ################################
/**
 * VanLoanAcct
 * VanLoanAcct.txt
 */
exports.ValleyBankVanLoanAcctSchema = zod_1.z.object({
    loan_id: zod_1.z.string(),
    product_code: zod_1.z.string(),
    loan_type_code: zod_1.z.string(),
    account_num: zod_1.z.string(),
    status_code: zod_1.z.string(),
    loan_status_sub_code: zod_1.z.string(),
    commercial_flag: zod_1.z.string(),
    orig_date: finley_types_1.Util.ZodFullDateStrStruct,
    orig_amt: zod_1.z.number(),
    loan_date: finley_types_1.Util.ZodFullDateStrStruct,
    current_loan_amount: zod_1.z.number(),
    current_balance: zod_1.z.number(),
    current_available: zod_1.z.number(),
    maturity_date: zod_1.z.string().nullable(),
    secured_flag: zod_1.z.string(),
    interest_rate: zod_1.z.number(),
    account_name: zod_1.z.string().nullable(),
    cif_num: zod_1.z.string(),
    commitment_id: zod_1.z.string().nullable(),
    commitment_num: zod_1.z.string(),
    acct_rsk_rate: zod_1.z.string().nullable(),
    cost_center: zod_1.z.string(),
});
exports.FinleyVanLoanAcctSchema = exports.ValleyBankVanLoanAcctSchema.extend({
    reportingDate: finley_types_1.Util.ZodFullDateStrStruct,
});
/**
 * Loan Customer Relationships
 * Loan_cust_rel.TXT
 */
exports.ValleyBankLoanCustRelSchema = zod_1.z.object({
    heloan_as_of_dt: finley_types_1.Util.ZodFullDateStrStruct,
    heloan_bsys_id: zod_1.z.string(),
    heloan_acct_num: zod_1.z.string(), // account_num
    cif_num: zod_1.z.string().nullable(),
    helcrel_rel_type_id: zod_1.z.string(),
    helcrel_acct_type: zod_1.z.enum(['DP', 'LN']), // LN or DP
    helcrel_portfolio_number: zod_1.z.string().nullable(),
});
exports.FinleyLoanCustRelSchema = exports.ValleyBankLoanCustRelSchema.extend({
    reportingDate: finley_types_1.Util.ZodFullDateStrStruct,
});
/**
 * Valley Bank Van Commt
 * VANCMMT.TXT
 */
exports.ValleyBankVanCmmtSchema = zod_1.z.object({
    bank_num: zod_1.z.string(),
    commitment_id: zod_1.z.string(),
    account_num: zod_1.z.string(),
    commitment_num: zod_1.z.string(),
    type: zod_1.z.string(),
    partner_ind: zod_1.z.string(),
    partner_bank_num: zod_1.z.string(),
    lead_ind: zod_1.z.string(),
    partner_acct_num: zod_1.z.string(),
    partner_commitment_num: zod_1.z.string(),
    ultim_acct_num: zod_1.z.string(),
    ultim_commitment_num: zod_1.z.string(),
    level: zod_1.z.number(),
    cost_center: zod_1.z.string().nullable(),
    branch: zod_1.z.string(),
    revolve_ind: zod_1.z.string(),
    draw_ind: zod_1.z.string(),
    term: zod_1.z.number(),
    expire_date: zod_1.z.string().nullable(),
    renewal_date: zod_1.z.string().nullable(),
    review_date: zod_1.z.string().nullable(),
    current_amt: zod_1.z.number(),
    used_amt: zod_1.z.number(),
    unused_amt: zod_1.z.number(),
    avail_amt: zod_1.z.number(),
    adj_avail_amt: zod_1.z.number(),
    orig_amt: zod_1.z.number(),
    securd_ind: zod_1.z.string(),
    collat_code: zod_1.z.string().nullable(),
    active_status: zod_1.z.string().nullable(),
    cmudf_01: zod_1.z.string().nullable(),
    cif_num: zod_1.z.string(),
    account_name: zod_1.z.string().nullable(),
});
exports.FinleyVanCmmtSchema = exports.ValleyBankVanCmmtSchema.extend({
    reportingDate: finley_types_1.Util.ZodFullDateStrStruct,
});
/**
 * CUOLOAN
 * CUOLOAN.TXT
 */
exports.ValleyBankCuoLoanSchema = zod_1.z.object({
    heloan_as_of_dt: finley_types_1.Util.ZodFullDateStrStruct,
    heloan_bsys_id: zod_1.z.string(),
    heloan_bank_num: zod_1.z.string(),
    cif_num: zod_1.z.string().nullable(),
    heloan_acct_num: zod_1.z.string(),
    heloan_cur_bal: zod_1.z.number(),
    heloan_past_due_amt: zod_1.z.number().nullable(),
    heloan_days_past_due: zod_1.z.number().nullable(),
    heloan_last_pmt_dt: zod_1.z.string().nullable(),
    heloan_current_credit_line_comm: zod_1.z.number().nullable(),
    heloan_risk_grade: zod_1.z.string().nullable(),
    heloan_mat_dt: zod_1.z.string().nullable(),
    heloan_prod_type: zod_1.z.string(),
    heloan_int_rate: zod_1.z.number().nullable(),
    heloan_branch: zod_1.z.string().nullable(),
    heloan_note_dt: zod_1.z.string().nullable(),
    heloan_prod_type_desc: zod_1.z.string(),
    heloan_branch_desc: zod_1.z.string().nullable(),
    heloan_status: zod_1.z.string().nullable(),
    heloan_acct_status: zod_1.z.string(),
    heloan_orig_payment_amount: zod_1.z.number().nullable(),
    heloan_int_guar_code: zod_1.z.string().nullable(),
    heloan_relationship: zod_1.z.string().nullable(),
    heloan_parent_acct_num: zod_1.z.string().nullable(),
    heloan_universal_num: zod_1.z.string().nullable(),
    heloan_avg_variance: zod_1.z.string().nullable(),
    heloan_avail_amt: zod_1.z.number().nullable(),
    heloan_next_pmt_dt: zod_1.z.string().nullable(),
    heloan_frgn_currency_code: zod_1.z.string().nullable(),
    heloan_frgn_cur_xfr_rate: zod_1.z.number().nullable(),
    heloan_frgn_orig_amt: zod_1.z.number().nullable(),
    heloan_frgn_cur_amt: zod_1.z.number().nullable(),
    heloan_secured_ind: zod_1.z.string().nullable(),
    heloan_collat_analysis_bal: zod_1.z.number().nullable(),
});
exports.FinleyCuoLoanSchema = exports.ValleyBankCuoLoanSchema.extend({
    reportingDate: finley_types_1.Util.ZodFullDateStrStruct,
});
/**
 * CuoMaint
 * CUOMAINT.TXT
 */
exports.ValleyBankCuoMaintSchema = zod_1.z.object({
    heloan_as_of_dt: finley_types_1.Util.ZodFullDateStrStruct,
    heloan_bsys_id: zod_1.z.string(),
    heloan_bank_num: zod_1.z.string(),
    heloan_cust_num: zod_1.z.string().nullable(),
    heloan_acct_num: zod_1.z.string(), // commitment_id
    heloan_obgat_num: zod_1.z.string(),
    heloan_cur_bal: zod_1.z.number(),
    heloan_collat_analysis_bal: zod_1.z.number(),
});
exports.FinleyCuoMaintSchema = exports.ValleyBankCuoMaintSchema.extend({
    reportingDate: finley_types_1.Util.ZodFullDateStrStruct,
});
// ################################
// #
// # PS PLUS
// #
// ################################
/**
 * PS Plus Portfolio - Arrangement Group Mapping
 * PSPLUS_PORTFOLIO_MAPPING.TXT
 */
exports.ValleyBankPsPlusPortfolioSchema = zod_1.z.object({
    hecoll_id: zod_1.z.string(),
    cif_num: zod_1.z.string(),
    heccrel_portfolio_number: zod_1.z.string(),
});
exports.FinleyPsPlusPortfolioSchema = exports.ValleyBankPsPlusPortfolioSchema.extend({
    reportingDate: finley_types_1.Util.ZodFullDateStrStruct,
});
exports.ValleyBankPsPlusAccountSchema = zod_1.z.object({
    hecoll_as_of_dt: finley_types_1.Util.ZodFullDateStrStruct,
    hecoll_bsys_id: zod_1.z.string(),
    hecoll_bank_num: zod_1.z.string(),
    hecoll_id: zod_1.z.string(), // account_num
    hecoll_collateral_account_number: zod_1.z.string(), // account_num, same as hecoll_id
    hecoll_desc: zod_1.z.string(),
    hecoll_desc_2: zod_1.z.string(),
    hecoll_current_appraisal: zod_1.z.number(),
    hecoll_type_code: zod_1.z.string(), // 38 for security account
    hecoll_pledged_ind: zod_1.z.string(), // Y or N to indicate pledging
});
exports.FinleyPsPlusAccountSchema = exports.ValleyBankPsPlusAccountSchema.extend({
    reportingDate: finley_types_1.Util.ZodFullDateStrStruct,
});
/**
 * PS Plus Security Detail
 * PSPLUS_SECDETAIL_MAPPING.TXT
 */
exports.ValleyBankPsPlusSecDetailSchema = zod_1.z.object({
    he_secd_as_of_dt: finley_types_1.Util.ZodFullDateStrStruct,
    he_secd_bank_num: zod_1.z.string(),
    hecoll_collateral_account_number: zod_1.z.string(),
    he_sec_security_num: zod_1.z.string(),
    he_secd_src_system: zod_1.z.string(),
    he_secd_src_system_id: zod_1.z.string(),
    he_secd_pldg_yn: zod_1.z.string(),
    he_secd_pldg_unit: zod_1.z.number(),
    he_secd_pldg_amt_us: zod_1.z.number(),
    he_secd_pldg_amt_fx: zod_1.z.number(),
    he_secd_unpldg_unit: zod_1.z.number(),
    he_secd_unpldg_amt_us: zod_1.z.number(),
    he_secd_unpldg_amt_fx: zod_1.z.number(),
    he_secd_ovrd_flg: zod_1.z.string().nullable(),
    he_secd_last_updt: zod_1.z.string().nullable(),
    he_secd_last_updt_by: zod_1.z.string().nullable(),
    he_secd_adv_rt: zod_1.z.number().nullable(),
    he_secd_unit_price_fx: zod_1.z.number(),
    he_secd_unit_price_us: zod_1.z.number(),
    hecoll_id: zod_1.z.string(),
    he_secd_frgn_cur_fxr_rate: zod_1.z.number(),
    currency_code: zod_1.z.string(),
});
exports.FinleyPsPlusSecDetailSchema = exports.ValleyBankPsPlusSecDetailSchema.extend({
    reportingDate: finley_types_1.Util.ZodFullDateStrStruct,
});
/**
 * PS Plus Security Master
 * PSPLUS_SECMASTER_MAPPING.TXT
 */
exports.ValleyBankPsPlusSecMasterSchema = zod_1.z.object({
    he_sec_as_of_dt: finley_types_1.Util.ZodFullDateStrStruct,
    he_sec_bsys_id: zod_1.z.string(),
    he_sec_bank_num: zod_1.z.string(),
    he_sec_security_num: zod_1.z.string(),
    he_sec_cusip: zod_1.z.string(),
    he_sec_country_key: zod_1.z.string(),
    he_sec_currency: zod_1.z.string(),
    he_sec_sec_desc: zod_1.z.string(),
    he_sec_unit_type: zod_1.z.string(),
    he_sec_ticker_symbol: zod_1.z.string().nullable(),
    he_sec_short_name: zod_1.z.string(),
    he_sec_issuer: zod_1.z.string().nullable(),
    he_sec_issuer_country: zod_1.z.string().nullable(),
    he_sec_asset_class: zod_1.z.string(),
    he_sec_price_date: finley_types_1.Util.ZodFullDateStrStruct,
    he_sec_unit_price_us: zod_1.z.number(),
    he_sec_exchange: zod_1.z.string().nullable(),
    he_sec_rating: zod_1.z.string(),
    he_sec_rating_src: zod_1.z.string().nullable(),
    he_sec_issue_dt: zod_1.z.string().nullable(),
    he_sec_mat_dt: zod_1.z.string().nullable(),
    he_sec_redemp_dt: zod_1.z.string().nullable(),
    he_sec_int_start: zod_1.z.string().nullable(),
    he_sec_coupon_per_yr: zod_1.z.number().nullable(),
    he_sec_int_type: zod_1.z.string().nullable(),
    he_sec_asset_class_code: zod_1.z.string(),
    he_sec_segment_code: zod_1.z.string(),
    he_sec_strategy_code: zod_1.z.string(),
    he_sec_long_desc: zod_1.z.string(),
    he_sec_strategy: zod_1.z.string(),
    he_sec_segment: zod_1.z.string(),
    he_par_logic: zod_1.z.number(),
});
exports.ValleyBankBloombergMutualFundSchema = zod_1.z.object({
    security_number: zod_1.z.string(),
    isin: zod_1.z.string(),
    market_sector_des: zod_1.z.string(),
    fund_strategy: zod_1.z.string().nullable(),
    eqy_fund_ind: zod_1.z.string().nullable(),
    fund_asset_class_focus: zod_1.z.string().nullable(),
    fund_rtg_class_focus: zod_1.z.string().nullable(),
    fund_geo_focus: zod_1.z.string().nullable(),
    fund_objective_long: zod_1.z.string().nullable(),
    hb_oas_eff_durtn: zod_1.z.string().nullable(),
    yas_mod_dur: zod_1.z.string().nullable(),
});
exports.FinleyPsPlusSecMasterSchema = zod_1.z.object({
    he_sec_security_num: zod_1.z.string(),
    he_sec_as_of_dt: finley_types_1.Util.ZodFullDateStrStruct.nullable(),
    he_sec_bsys_id: zod_1.z.string().nullable(),
    he_sec_bank_num: zod_1.z.string().nullable(),
    he_sec_cusip: zod_1.z.string().nullable(),
    he_sec_country_key: zod_1.z.string().nullable(),
    he_sec_currency: zod_1.z.string().nullable(),
    he_sec_sec_desc: zod_1.z.string().nullable(),
    he_sec_unit_type: zod_1.z.string().nullable(),
    he_sec_ticker_symbol: zod_1.z.string().nullable(),
    he_sec_short_name: zod_1.z.string().nullable(),
    he_sec_issuer: zod_1.z.string().nullable(),
    he_sec_issuer_country: zod_1.z.string().nullable(),
    he_sec_asset_class: zod_1.z.string().nullable(),
    he_sec_price_date: finley_types_1.Util.ZodFullDateStrStruct.nullable(),
    he_sec_unit_price_us: zod_1.z.number().nullable(),
    he_sec_exchange: zod_1.z.string().nullable(),
    he_sec_rating: zod_1.z.string().nullable(),
    he_sec_rating_src: zod_1.z.string().nullable(),
    he_sec_issue_dt: zod_1.z.string().nullable(),
    he_sec_mat_dt: zod_1.z.string().nullable(),
    he_sec_redemp_dt: zod_1.z.string().nullable(),
    he_sec_int_start: zod_1.z.string().nullable(),
    he_sec_coupon_per_yr: zod_1.z.number().nullable(),
    he_sec_int_type: zod_1.z.string().nullable(),
    he_sec_asset_class_code: zod_1.z.string().nullable(),
    he_sec_segment_code: zod_1.z.string().nullable(),
    he_sec_strategy_code: zod_1.z.string().nullable(),
    he_sec_long_desc: zod_1.z.string().nullable(),
    he_sec_strategy: zod_1.z.string().nullable(),
    he_sec_segment: zod_1.z.string().nullable(),
    he_par_logic: zod_1.z.number().nullable(),
    isin: zod_1.z.string().nullable(),
    market_sector_des: zod_1.z.string().nullable(),
    fund_strategy: zod_1.z.string().nullable(),
    eqy_fund_ind: zod_1.z.string().nullable(),
    fund_asset_class_focus: zod_1.z.string().nullable(),
    fund_rtg_class_focus: zod_1.z.string().nullable(),
    fund_geo_focus: zod_1.z.string().nullable(),
    fund_objective_long: zod_1.z.string().nullable(),
    hb_oas_eff_durtn: zod_1.z.string().nullable(),
    yas_mod_dur: zod_1.z.string().nullable(),
    reportingDate: finley_types_1.Util.ZodFullDateStrStruct,
});
// ################################
// #
// # COLLATERAL TRACKING
// #
// ################################
exports.ValleyBankCollateralToLoanAccountMappingSchema = zod_1.z.object({
    loanAccountNum: zod_1.z.string(),
    collateralAccountNum: zod_1.z.string(),
    collateralAccountType: exports.ValleyBankAccountCollateralTypeSchema,
    reportingDate: finley_types_1.Util.ZodFullDateStrStruct,
});
// ################################
// #
// # STATIC MAPPING
// #
// ################################
/**
 * Van List
 * VANLIST.TXT
 */
exports.ValleyBankVanListSchema = zod_1.z.object({
    bank_num: zod_1.z.string(),
    tablename: zod_1.z.string(),
    code: zod_1.z.string().nullable(),
    description: zod_1.z.string(),
});
exports.FinleyVanListSchema = exports.ValleyBankVanListSchema.extend({
    reportingDate: finley_types_1.Util.ZodFullDateStrStruct,
});
/**
 * Van Product
 * VANPRODUCT.TXT
 */
exports.ValleyBankVanProductSchema = zod_1.z.object({
    bank_num: zod_1.z.string(),
    product_code: zod_1.z.string(),
    product_desc: zod_1.z.string(),
    product_type: zod_1.z.string(),
    app_code: zod_1.z.string(),
    app_sub_code: zod_1.z.string().nullable(),
    call_code: zod_1.z.string().nullable(),
    active_flag: zod_1.z.string(),
});
exports.FinleyVanProductSchema = exports.ValleyBankVanProductSchema.extend({
    reportingDate: finley_types_1.Util.ZodFullDateStrStruct,
});
// ################################
// #
// # DERIVATIVE PATH
// #
// ################################
exports.ValleyBankDerivativePathSchema = zod_1.z.object({
    id: zod_1.z.string(),
    cif_num: zod_1.z.string(),
    account_num: zod_1.z.string().nullable(),
    notional_amount: zod_1.z.number(),
    source_currency: zod_1.z.string(),
    destination_currency: zod_1.z.string(),
    fx_rate: zod_1.z.number(),
    usd_current_notional_amount: zod_1.z.number(),
    initial_margin_requirement_rate: zod_1.z.number(),
    expiration_date: finley_types_1.Util.ZodFullDateStrStruct,
    mark_to_market: zod_1.z.number(),
    product: zod_1.z.string(),
    valuation_date: finley_types_1.Util.ZodFullDateStrStruct,
});
exports.FinleyDerivativePathSchema = zod_1.z.object({
    id: zod_1.z.string(),
    cif_num: zod_1.z.string(),
    account_num: zod_1.z.string(),
    notional_amount: zod_1.z.number(),
    source_currency: zod_1.z.string(),
    destination_currency: zod_1.z.string(),
    fx_rate: zod_1.z.number(),
    usd_current_notional_amount: zod_1.z.number(),
    initial_margin_requirement_rate: zod_1.z.number(),
    expiration_date: finley_types_1.Util.ZodFullDateStrStruct,
    mark_to_market: zod_1.z.number(),
    product: zod_1.z.string(),
    valuation_date: finley_types_1.Util.ZodFullDateStrStruct,
    reportingDate: finley_types_1.Util.ZodFullDateStrStruct,
    exposure: zod_1.z.number(),
    initial_margin_requirement_amount: zod_1.z.number(),
});
exports.valleyBankRequiredBaseFieldsIterable = [
    'finley_assigned_to_loan_accounts',
    'finley_receivable_id',
    'finley_loan_product_id',
    'loan_account_number',
    'arrangement_group',
    'cif_num',
    'collateral_account_number',
    'finley_valuation_rate',
    'finley_exposure',
    'pre_allocation_lendable_value',
    'post_allocation_lendable_value',
    'product_name',
];
// NOTE - historical records must be migrated when introducing new required base fields
// OR new fields must be optional
// fields that are required to be part of base fields.
// anything that starts with `finley_` is for internal
// consumption, and should not be exposed to user.
exports.ValleyBankRequiredBaseFieldsSchema = zod_1.z.object({
    // ValleyBankAssignmentBaseFields
    finley_assigned_to_loan_accounts: zod_1.z.string().nullable(),
    loan_account_number: zod_1.z.string().nullable(),
    // ValleyBankOtherRequiredBaseFields
    reporting_date: finley_types_1.Util.ZodFullDateStrStruct,
    finley_receivable_id: zod_1.z.string(),
    finley_loan_product_id: zod_1.z.string().nullable(),
    finley_exposure: zod_1.z.number(),
    arrangement_group: zod_1.z.string().nullable(),
    cif_num: zod_1.z.string(),
    collateral_account_number: zod_1.z.string(),
    collateral_account_type: exports.ValleyBankAccountCollateralTypeSchema,
    finley_valuation_rate: zod_1.z.number(),
    pre_allocation_lendable_value: zod_1.z.number(),
    post_allocation_lendable_value: zod_1.z.number(),
    product_name: zod_1.z.string(),
});
// valley_bank_rrt TABLE
exports.FinleyValleyBankResponseTapeRowSchema = zod_1.z.object({
    // ValeyBankBaseFieldColumns fields
    finley_receivable_id: zod_1.z.string(),
    finley_loan_product_id: zod_1.z.string().nullable(),
    loan_account_number: zod_1.z.string().nullable(),
    arrangement_group: zod_1.z.string().nullable(),
    cif_num: zod_1.z.string(),
    collateral_account_number: zod_1.z.string(),
    reportingDate: finley_types_1.Util.ZodFullDateStrStruct,
    isPreview: zod_1.z.boolean(),
    creditAgreementId: zod_1.z.string().nullable(),
    receivableReponseTapeRow: zod_1.z.custom(),
});
exports.finleyAssignmentFieldsIterable = [
    'finley_receivable_id',
    'finley_assigned_to_loan_accounts',
    'finley_loan_product_id',
    'loan_account_number',
    'finley_valuation_rate',
    'finley_exposure',
];
exports.ValleyBankSubLoanAccountTypeSchema = zod_1.z.enum([
    'standAloneNote',
    'commitment',
    'commitmentNote',
    'derivativePath',
]);
exports.ValleyBankSubLoanAccountSchema = zod_1.z.object({
    type: exports.ValleyBankSubLoanAccountTypeSchema,
    accountNumber: zod_1.z.string(),
    commitmentId: zod_1.z.string().nullable(),
    noteId: zod_1.z.string().nullable(),
    derivativePathId: zod_1.z.string().nullable(),
    productDescription: zod_1.z.string().nullable(),
    loanAmount: zod_1.z.number().nullable(),
    noteDate: zod_1.z.string().nullable(),
    maturityDate: zod_1.z.string().nullable(),
    interestRate: zod_1.z.number().nullable(),
    currency: zod_1.z.string().nullable(),
    fxAmount: zod_1.z.number().nullable(),
    fxRate: zod_1.z.number().nullable(),
    currentBalance: zod_1.z.number().nullable(),
    source: zod_1.z.string(),
    contributesToPrincipalBalance: zod_1.z.boolean(),
    ultimateCommitmentId: zod_1.z.string().nullable(),
    valuationDate: zod_1.z.string().nullable(),
    usdCurrentNotionalAmount: zod_1.z.number().nullable(),
    initialMarginRequirementRate: zod_1.z.number().nullable(),
    initialMarginRequirementAmount: zod_1.z.number().nullable(),
    markToMarket: zod_1.z.number().nullable(),
});
exports.ValleyBankHistoricalLoanAccountToPinnedCommentSchema = zod_1.z.object({
    reportingDate: finley_types_1.Util.ZodFullDateStrStruct,
    pinnedCommentId: zod_1.z.string(),
    loanAccountNumber: zod_1.z.string(),
});
exports.ValleyBankCollateralAccountSchema = zod_1.z.object({
    accountNumber: zod_1.z.string(),
    cifNum: zod_1.z.string(),
    owner: exports.FinleyVanCustWithOfficerSchema.nullable(),
    productName: zod_1.z.string(),
    marketValue: zod_1.z.number(),
    effectiveAdvanceRate: zod_1.z.number(),
    preAllocationLendableValue: zod_1.z.number(),
    effectiveAllocation: zod_1.z.number(),
    postAllocationLendableValue: zod_1.z.number(),
    receivables: zod_1.z.array(exports.FinleyValleyBankResponseTapeRowSchema),
});
exports.ValleyBankCustomerSchema = exports.FinleyVanCustWithOfficerSchema.pick({
    cif_num: true,
    bank_num: true,
    full_name: true,
    address_1: true,
    address_2: true,
    city: true,
    state: true,
    zip_code: true,
    officer_code: true,
    customer_since: true,
    naics_code: true,
    branch_code: true,
    ci_risk_rt: true,
    prospcd: true,
    officer: true,
    reportingDate: true,
}).extend({
    asOfDate: finley_types_1.Util.ZodFullDateStrStruct,
});
exports.ValleyBankLoanAccountWithCollateralStatsSchema = zod_1.z.object({
    // ValleyBankLoanAccountMetadata
    loanAccountNumber: zod_1.z.string(),
    accountName: zod_1.z.string().nullable(),
    cifNum: zod_1.z.string(),
    reportingDate: finley_types_1.Util.ZodFullDateStrStruct,
    asOfDate: finley_types_1.Util.ZodFullDateStrStruct,
    // ValleyBankLoanAccount
    arrangementGroupId: zod_1.z.string().nullable(),
    principalBalance: zod_1.z.number(),
    totalLoanAmount: zod_1.z.number().nullable(),
    commitments: zod_1.z.array(exports.ValleyBankSubLoanAccountSchema),
    commitmentNotes: zod_1.z.array(exports.ValleyBankSubLoanAccountSchema),
    standAloneNotes: zod_1.z.array(exports.ValleyBankSubLoanAccountSchema),
    derivativePathLoans: zod_1.z.array(exports.ValleyBankSubLoanAccountSchema),
    loanParties: zod_1.z.array(exports.FinleyLoanPartySchema),
    // ValleyBankLoanAccountCollateralStats
    totalMarketValue: zod_1.z.number(),
    effectiveAdvanceRate: zod_1.z.number(),
    effectiveAllocationRate: zod_1.z.number(),
    totalLendableValue: zod_1.z.number(),
    totalPostAllocationLendableValue: zod_1.z.number(),
    marginAvailable: zod_1.z.number(),
    marginAvailabilityRate: zod_1.z.number(),
});
exports.ValleyBankLoanAccountWithCollateralAndStatsSchema = zod_1.z.object({
    // ValleyBankLoanAccountMetadata
    loanAccountNumber: zod_1.z.string(),
    accountName: zod_1.z.string().nullable(),
    cifNum: zod_1.z.string(),
    reportingDate: finley_types_1.Util.ZodFullDateStrStruct,
    asOfDate: finley_types_1.Util.ZodFullDateStrStruct,
    // ValleyBankLoanAccount
    arrangementGroupId: zod_1.z.string().nullable(),
    principalBalance: zod_1.z.number(),
    totalLoanAmount: zod_1.z.number().nullable(),
    commitments: zod_1.z.array(exports.ValleyBankSubLoanAccountSchema),
    commitmentNotes: zod_1.z.array(exports.ValleyBankSubLoanAccountSchema),
    standAloneNotes: zod_1.z.array(exports.ValleyBankSubLoanAccountSchema),
    derivativePathLoans: zod_1.z.array(exports.ValleyBankSubLoanAccountSchema),
    loanParties: zod_1.z.array(exports.FinleyLoanPartySchema),
    // ValleyBankLoanAccountWithCollateral
    collateralAccounts: zod_1.z.array(exports.ValleyBankCollateralAccountSchema),
    // ValleyBankLoanAccountCollateralStats
    totalMarketValue: zod_1.z.number(),
    effectiveAdvanceRate: zod_1.z.number(),
    effectiveAllocationRate: zod_1.z.number(),
    totalLendableValue: zod_1.z.number(),
    totalPostAllocationLendableValue: zod_1.z.number(),
    marginAvailable: zod_1.z.number(),
    marginAvailabilityRate: zod_1.z.number(),
});
exports.ValleyBankCustomerWithRelationshipsSchema = zod_1.z.object({
    // ValleyBankCustomer fields (Pick from FinleyVanCustWithOfficer)
    cif_num: zod_1.z.string(),
    bank_num: zod_1.z.string(),
    full_name: zod_1.z.string(),
    address_1: zod_1.z.string().nullable(),
    address_2: zod_1.z.string().nullable(),
    city: zod_1.z.string().nullable(),
    state: zod_1.z.string().nullable(),
    zip_code: zod_1.z.string().nullable(),
    officer_code: zod_1.z.string(),
    customer_since: finley_types_1.Util.ZodFullDateStrStruct,
    naics_code: zod_1.z.string().nullable(),
    branch_code: zod_1.z.string(),
    ci_risk_rt: zod_1.z.string().nullable(),
    prospcd: zod_1.z.string(),
    officer: zod_1.z.string().nullable(),
    reportingDate: finley_types_1.Util.ZodFullDateStrStruct,
    asOfDate: finley_types_1.Util.ZodFullDateStrStruct,
    // Own fields
    collateralAccounts: zod_1.z.array(exports.ValleyBankCollateralAccountSchema),
    loanAccounts: zod_1.z.array(exports.ValleyBankLoanAccountWithCollateralStatsSchema),
});
exports.ValleyBankReceivableResponseTapeWorkleaseSchema = zod_1.z.object({
    reportingDate: finley_types_1.Util.ZodFullDateStrStruct,
    asOfDate: finley_types_1.Util.ZodFullDateStrStruct,
    creditAgreementId: zod_1.z.string().nullable(),
    type: zod_1.z.literal('refresh'),
});
exports.ValleyBankRestoreWorkleaseSchema = zod_1.z.object({
    reportingDate: finley_types_1.Util.ZodFullDateStrStruct,
    asOfDate: finley_types_1.Util.ZodFullDateStrStruct,
    creditAgreementId: zod_1.z.string(),
    type: zod_1.z.literal('restore'),
});
exports.ValleyBankArchiveWorkleaseSchema = zod_1.z.object({
    type: zod_1.z.literal('archive'),
});
exports.ValleyBankWorkleaseSchema = zod_1.z.discriminatedUnion('type', [
    exports.ValleyBankReceivableResponseTapeWorkleaseSchema,
    exports.ValleyBankRestoreWorkleaseSchema,
    exports.ValleyBankArchiveWorkleaseSchema,
]);
exports.ValleyBankPortfolioReceivableResponseTapeSchema = zod_1.z.object({
    // ValleyBankPortfolioReceivableResponseTapeAllStats fields
    unassignedTotalMarketValue: zod_1.z.number().nullable(),
    unassignedTotalLendableValue: zod_1.z.number().nullable(),
    unassignedEffectiveAdvanceRate: zod_1.z.number().nullable(),
    unassignedCollateralAccountsCount: zod_1.z.number().nullable(),
    assignedTotalMarketValue: zod_1.z.number().nullable(),
    assignedTotalLendableValue: zod_1.z.number().nullable(),
    assignedEffectiveAdvanceRate: zod_1.z.number().nullable(),
    assignedCollateralAccountsCount: zod_1.z.number().nullable(),
    totalOutstandingBalance: zod_1.z.number().nullable(),
    totalMarginAvailability: zod_1.z.number().nullable(),
    totalMarginAvailabilityRate: zod_1.z.number().nullable(),
    loanAccountsCount: zod_1.z.number().nullable(),
    underMarginStatusCount: zod_1.z.number().nullable(),
    nearMarginStatusCount: zod_1.z.number().nullable(),
    excessMarginStatusCount: zod_1.z.number().nullable(),
    // ValleyBankDownloadLocations fields
    ingestionLogsS3Location: zod_1.z.custom().nullable(),
    securitiesExtendedResponseTapeS3Location: zod_1.z
        .custom()
        .nullable(),
    depositsExtendedResponseTapeS3Location: zod_1.z
        .custom()
        .nullable(),
    loanAccountDetailsS3Location: zod_1.z.custom().nullable(),
    collateralAssignmentsS3Location: zod_1.z.custom().nullable(),
    // Own fields
    reportingDate: finley_types_1.Util.ZodFullDateStrStruct,
    isPreview: zod_1.z.boolean(),
    asOfDate: finley_types_1.Util.ZodFullDateStrStruct,
    creditAgreementId: zod_1.z.string().nullable(),
    metadata: zod_1.z.object({
        status: zod_1.z.enum(['failure', 'success', 'in-progress']),
        details: zod_1.z.array(zod_1.z.string()),
    }),
});
exports.ValleyBankPortfolioReceivableResponseTapeStatsSchema = zod_1.z.object({
    // NonNullableProperties of ValleyBankPortfolioReceivableResponseTapeAllStats fields
    unassignedTotalMarketValue: zod_1.z.number(),
    unassignedTotalLendableValue: zod_1.z.number(),
    unassignedEffectiveAdvanceRate: zod_1.z.number(),
    unassignedCollateralAccountsCount: zod_1.z.number(),
    assignedTotalMarketValue: zod_1.z.number(),
    assignedTotalLendableValue: zod_1.z.number(),
    assignedEffectiveAdvanceRate: zod_1.z.number(),
    assignedCollateralAccountsCount: zod_1.z.number(),
    totalOutstandingBalance: zod_1.z.number(),
    totalMarginAvailability: zod_1.z.number(),
    totalMarginAvailabilityRate: zod_1.z.number(),
    loanAccountsCount: zod_1.z.number(),
    underMarginStatusCount: zod_1.z.number(),
    nearMarginStatusCount: zod_1.z.number(),
    excessMarginStatusCount: zod_1.z.number(),
    // ValleyBankDownloadLocations fields
    ingestionLogsS3Location: zod_1.z.custom().nullable(),
    securitiesExtendedResponseTapeS3Location: zod_1.z
        .custom()
        .nullable(),
    depositsExtendedResponseTapeS3Location: zod_1.z
        .custom()
        .nullable(),
    loanAccountDetailsS3Location: zod_1.z.custom().nullable(),
    collateralAssignmentsS3Location: zod_1.z.custom().nullable(),
});
exports.ValleyBankPipelineStatusMetadataSchema = zod_1.z.object({
    metadata: zod_1.z.object({
        status: zod_1.z.enum(['failure', 'success', 'in-progress']),
        details: zod_1.z.array(zod_1.z.string()),
    }),
    portfolioStats: exports.ValleyBankPortfolioReceivableResponseTapeSchema.omit({
        metadata: true,
    }),
});
exports.ValleyBankArrangementGroupSchema = zod_1.z.object({
    arrangementGroupNumber: zod_1.z.string(),
    loanAccounts: zod_1.z.array(exports.ValleyBankLoanAccountWithCollateralAndStatsSchema),
    collateralAccounts: zod_1.z.array(exports.ValleyBankCollateralAccountSchema),
    customers: zod_1.z.array(exports.ValleyBankCustomerSchema),
});
exports.ValleyBankLoanAccountStatsSchema = zod_1.z.object({
    loanAccountNumber: zod_1.z.string(),
    outstandingBalance: zod_1.z.number(),
    assignedMarketValue: zod_1.z.number(),
    assignedPreAllocationLendableValue: zod_1.z.number(),
    assignedPostAllocationLendableValue: zod_1.z.number(),
    marginAvailability: zod_1.z.number(),
    marginAvailabilityRate: zod_1.z.number(),
    effectiveAdvanceRate: zod_1.z.number(),
    effectiveAllocationRate: zod_1.z.number(),
    marginAvailabilityStatus: zod_1.z.enum([
        'underMargin',
        'nearMargin',
        'excessMargin',
    ]),
    nearMarginThreshold: zod_1.z.number(),
    reportingDate: finley_types_1.Util.ZodFullDateStrStruct,
    asOfDate: finley_types_1.Util.ZodFullDateStrStruct,
    isPreview: zod_1.z.boolean(),
    creditAgreementId: zod_1.z.string().nullable(),
});
exports.ValleyBankCollateralAccountStatsSchema = zod_1.z.object({
    collateralAccountNumber: zod_1.z.string(),
    collateralAccountType: exports.ValleyBankAccountCollateralTypeSchema,
    totalMarketValue: zod_1.z.number(),
    totalPreAllocationLendableValue: zod_1.z.number(),
    totalPostAllocationLendableValue: zod_1.z.number(),
    effectiveAdvanceRate: zod_1.z.number(),
    effectiveAllocationRate: zod_1.z.number(),
    reportingDate: finley_types_1.Util.ZodFullDateStrStruct,
    asOfDate: finley_types_1.Util.ZodFullDateStrStruct,
    isPreview: zod_1.z.boolean(),
    creditAgreementId: zod_1.z.string().nullable(),
});
exports.VALLEY_BANK_USER_ROLES = [
    'ADMIN',
    'MEMBER',
    'CONTRIBUTOR',
];
exports.VALLEY_BANK_AUTH_ASSIGNMENT_SCOPES = [
    // allows a user to be able to add or delete from the assignment queue
    'assignment.queue:edit',
    // allows a user to be able to submit the assignment queue
    'assignment.queue:submit',
];
exports.VALLEY_BANK_AUTH_ADVANCE_RATE_SCOPES = [
    // can save a WIP (Preview mode on dashboard) advance rate
    'advanceRate:save',
    // can commit current WIP advance rate
    'advanceRate:commit',
];
//# sourceMappingURL=types.js.map